import {
  IonContent,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonListHeader,
  IonMenu,
  IonMenuToggle,
  IonNote,
} from '@ionic/react';

import React, { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { homeOutline, homeSharp, searchOutline, searchSharp, exitOutline, exitSharp, logInOutline, logInSharp, informationOutline, informationSharp } from 'ionicons/icons';
import './Menu.css';
import authService from '../services/AuthService';

import { HOME_ROUTER, WORDS_ROUTER, ABOUT_ROUTER } from '../Routers'

interface RouterPage {
  url: string;
  iosIcon: string;
  mdIcon: string;
  title: string;
  action?: () => any;
}

const Menu: React.FC = () => {
  const location = useLocation();

  const [appPages, setAppPages] = useState<RouterPage[]>([]);

  const defineMenu = useCallback((isAuthenticated) => {
    const routers: RouterPage[] = [
      {
        title: 'Início',
        url: HOME_ROUTER,
        iosIcon: homeOutline,
        mdIcon: homeSharp
      },
      // {
      //   title: 'Perfil',
      //   url: PROFILE_ROUTER,
      //   iosIcon: personOutline,
      //   mdIcon: personSharp
      // },
      {
        title: 'Pesquisar',
        url: WORDS_ROUTER,
        iosIcon: searchOutline,
        mdIcon: searchSharp
      },
      {
        title: 'Sobre',
        url: ABOUT_ROUTER,
        iosIcon: informationOutline,
        mdIcon: informationSharp
      }
    ]

    if (isAuthenticated) {
      routers.push({
        title: 'Sair',
        url: '/logout',
        iosIcon: exitOutline,
        mdIcon: exitSharp,
        action: () => {
          defineMenu(false)
        }
      })
    } else {
      routers.push({
        title: 'Login',
        url: '/auth',
        iosIcon: logInOutline,
        mdIcon: logInSharp
      })
    }

    setAppPages(routers)
  }, [])

  useEffect(() => {
    const unsubscribe = authService.observeAuth(isAuthenticated => {
      defineMenu(isAuthenticated)
    })

    return () => {
      unsubscribe()
    }
  }, [defineMenu])

  return (
    <IonMenu contentId="main" type="overlay">
      <IonContent>
        <IonList id="inbox-list">
          <IonListHeader>CoLibras</IonListHeader>
          <IonNote>UFRN</IonNote>

          {appPages.map((appPage, index) =>
            <IonMenuToggle key={index} autoHide={false}>
              <IonItem className={location.pathname === appPage.url ? 'selected' : ''} routerLink={appPage.url} routerDirection="none" lines="none" detail={false}>
                <IonIcon slot="start" icon={appPage.iosIcon} />
                <IonLabel>{appPage.title}</IonLabel>
              </IonItem>
            </IonMenuToggle>
          )}
        </IonList>
      </IonContent>
    </IonMenu>
  );
};

export default Menu;
